const LOGO_URL =
  "https://storage.helloreaddy.io/project_files/dca270cf-0162-487f-a6d1-8d419d40b89f/31481846-02d6-4bbf-930b-726b4349638f_compressed_logo-clem.webp";

export default function Logo({
  className = "",
  imgClassName = "h-12 w-auto md:h-14",
}: {
  className?: string;
  imgClassName?: string;
}) {
  return (
    <a
      href="#inicio"
      aria-label="CLEM by Cerón, ir al inicio"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="CLEM by Cerón"
        className={`block object-contain ${imgClassName}`}
      />
    </a>
  );
}